<template>
	<!-- 商户进件 -->
	<div class="merchantList">
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="searchForm" class="demo-form-inline">
				<el-form-item>
					<el-input size clearable v-model="searchForm.agent_phone" placeholder="请输入代理账号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="searchForm.agent_name" placeholder="请输入代理名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="searchForm.agent_no" placeholder="请输入代理编号"></el-input>
				</el-form-item>
				
				<el-form-item>
					<el-select
					v-model="searchForm.brand_id"
					filterable
					clearable
					placeholder="请选择政策名称">
					<el-option
					v-for="(item,index) in brandList"
					:key="index"
					:label="item.name"
					:value="item.id"
					></el-option>  
					</el-select>
				</el-form-item>
				
				<el-form-item>
					<el-select size v-model="searchForm.status" clearable placeholder="请选择状态">
						<el-option label="有效" value="1"></el-option>
						<el-option label="无效" value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-date-picker v-model="rangeDate" type="datetimerange" range-separator="至"
						start-placeholder="更新开始日期" end-placeholder="更新结束日期" value-format="yyyy-MM-dd"
						@change="pickerChange"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(searchForm)">查询</el-button>
					<el-button size="medium" type="primary" icon="el-icon-plus" style="font-size: 12px;"
						@click="addLimits()">添加黑名单</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<el-table :data="marchantList" size="mini" border style="width: 100%" v-loading="loading">
				<!-- 序号 -->
				<el-table-column header-align="center" align="center" fixed type="index" label="ID"
					min-width="80"></el-table-column>
				<el-table-column header-align="center" align="center" prop="agent_phone" label="代理商账号" min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="agent_name" label="代理商名称" min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="agent_no" label="代理商编号" min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="level" label="层级" min-width="120"></el-table-column>
				
				<el-table-column header-align="center" align="center" prop="brand_name" label="政策名称" min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="parent_agent_name" label="直属代理商名称"  min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="parent_agent_no" label="直属代理商编号" min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="second_agent_name" label="所属机构名称" min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="second_agent_no" label="所属机构编号" min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="status" label="状态" min-width="120">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 1">有效</span>
						<span v-else-if="scope.row.status == 2">无效</span>
					</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="update_time" label="创建时间" min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="update_time" label="更新时间" min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" fixed="right" label="操作" min-width="150">
					<template slot-scope="scope">
						<el-button @click="deactivate(scope.row,2)" type="text" size="small" v-if="scope.row.status == 1">停用</el-button>
						<el-button @click="deactivate(scope.row,1)" type="text" size="small" v-if="scope.row.status == 2">启用</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页部分 -->
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:page-sizes="[10,20,50,100]" :current-page="currentPage" :page-size="pageSize" :total="total"
				layout="total, sizes, prev, pager, next, jumper"></el-pagination>
		</el-card>

		<el-dialog title="添加黑名单" :visible.sync="dialogVisible" width="50%" :close-on-click-modal="false"
			:before-close="handleClose">

			<el-form  :model="formInline" label-width="120px" :rules="rules" ref="ruleForm" class="addForm">
				<el-form-item label="代理商账号" prop="agent_no">
					<el-input v-model="formInline.agent_no" clearable @blur="agentApi"  :disabled="inputState"></el-input>
				</el-form-item>
				<el-form-item label="代理商名称" prop="agent_nname">
					<el-input v-model="formInline.agent_name" disabled></el-input>
				</el-form-item>
				<el-form-item label="政策名称" prop="brand_id">
					<el-select v-model="formInline.brand_id" clearable :disabled="inputState">
						<el-option v-for="item in policyOption" :label="item.name" :value="item.id"
							:key="item.id"></el-option>
					</el-select>
				</el-form-item>
				<!-- <el-form-item label="是否恢复该代理商商户的费率为调价前费率/秒到费" prop="is_restore" label-width="350px">
					<el-radio-group v-model="formInline.is_restore">
						<el-radio :label="1">否</el-radio>
						<el-radio :label="2">是</el-radio>
					</el-radio-group>
				</el-form-item> -->
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose()">取 消</el-button>
				<el-button type="primary" @click="save()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: "rightsManagement",
		data() {
			return {
				searchForm: {
					agent_phone:'',
					agent_name:'',
					agent_no:'',
					brand_id:'',
					status: '',
					start_time: '',
					end_time: '',
				},
				rangeDate: '',
				id: '',
				marchantList: [],
				currentPage: 1, //当前页码
				pageSize: 10, //条数
				total: 0, //总数
				loading: true,
				level: sessionStorage.getItem('level'),
				brandList: [],
				//添加政策
				dialogVisible: false,
				formInline: {
					user_id: '',
					agent_name: '',
					brand_id: '',
					is_restore:1,
				},
				inputState:false,
				//政策
				policyOption: [],
				rules: {
					agent_no: [{
						required: true,
						message: '请输入代理商编号',
						trigger: 'blur'
					}],
					brand_id: [{
						required: true,
						message: '请选择政策',
						trigger: 'change'
					}],
					is_restore: [{
						required: true,
						message: '请选择是否恢复代理费率',
						trigger: 'change'
					}],
				}
			}
		},
		created() {

		},
		mounted() {
			this.$api.post('brand/brand_list', {}, res => { //获取终端类型
                if (res.code == 0) {
                    this.brandList = res.data.list;
                } else {
                    this.$message.success(res.msg);
                }  
			});
			this.getData({
				page: 1,
				limit: 10
			})
		},
		methods: {
			onSearch(searchFrom) {
				this.currentPage = 1;
				searchFrom.page = 1;
				this.getData(searchFrom);
			},
			getData(params) { //获取数据
				this.loading = true;
				this.$api.post("rateup/blackList", params, res => {
					let data = res.data;
					this.total = data.count; //总数
					this.marchantList = res.data.list;
					//渲染结束后取消加载
					this.loading = false;
				})
			},
			handleCurrentChange(page) { //当前选中页
				this.currentPage = page;
				this.searchForm.page = page;
				this.searchForm.limit = this.pageSize;
				this.getData(this.searchForm);
			},
			handleSizeChange(limit) { //条数
				this.currentPage = 1;
				this.pageSize = limit;
				this.searchForm.page = 1;
				this.searchForm.limit = limit;
				this.getData(this.searchForm);
			},
			pickerChange(DateArr) { //时间选择器
				this.searchForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
				this.searchForm.end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
			},

			//新增调价权限
			addLimits() {
				this.inputState = false;
				this.dialogVisible = true;
			},
			//关闭弹框
			handleClose() {
				this.dialogVisible = false;
				this.$refs['ruleForm'].resetFields();
				this.formInline = {
					user_id: "",
					is_restore: 1,
				}
			},
			//输入代理商编号查询数据
			agentApi() {
				this.$api.post("rateup/getUserBrand", {
					phone: this.formInline.agent_no
				}, res => {
					if (res.data) {
						if (res.data) {
							this.formInline.user_id = res.data.user_id;
							this.formInline.agent_name = res.data.nickname;
							this.policyOption = res.data.brand_list
						} else {
							this.formInline.user_id = null;
							this.formInline.agent_name = null;
							this.formInline.brand_id = null;
							this.policyOption = [];
						}
					}
				})
			},
			//保存
			save() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.$api.post("rateup/saveBlacklist", this.formInline, res => {
							if (res.code == 0) {
								this.$message.success(res.msg);
								this.handleClose();
								this.getData({
									page: 1,
									limit: 10
								})
							} else {
								this.$message.error(res.msg);
							}
						})
					} else {
						return false;
					}
				});
			},
			//停用
			deactivate(row,state) {
				let text = state == 1?'确定启用':'确定停用'
				this.$confirm(text, '提 示', {
					type: 'warning',
					distinguishCancelAndClose: true,
					confirmButtonText: '确 定',
					cancelButtonText: '取 消'
				}).then(() => {
					this.$api.post("rateup/editBlacklistStatus", {id:row.id,status:state}, res => {
						if (res.code == 0) {
							this.$message.success(res.msg);
							this.getData({
								page: 1,
								limit: 10
							})
						} else {
							this.$message.error(res.msg);
						}
					})
				}).catch(() => {})
			},
		}
	}
</script>

<style scoped lang="scss">
	.addForm{
		.el-form-item {
			margin-bottom: 20px;
		}
		
		.el-select,
		.el-input {
			width: 300px;
			font-size: 12px;
		}
	}
	
</style>